// extracted by mini-css-extract-plugin
export default {"myFundraisersRoute":"myFundraisersRoute__myFundraisersRoute--MLhsz","title":"myFundraisersRoute__title--Wnnw0"};